import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import VideoSkipForwardFifteenIcon from '@atlaskit/icon/core/video-skip-forward-fifteen';

import { useAudioPlayerStreamingContext } from '../../../context/AudioPlayerStreamingProvider';

import { AudioControlIconButton } from './sub-components/AudioControlButton';

const SKIP_SECONDS = 15;

const i18n = defineMessages({
	skipForwardButtonTooltip: {
		id: 'audio.miniplayer-controls.skip-forward-label',
		defaultMessage: 'Skip forward',
		description:
			'The label is used as a tooltip for the icon button which will skip the currently active audio forward "x" seconds',
	},
	skipForwardButtonLabel: {
		id: 'audio.miniplayer-controls.skip-forward-label',
		defaultMessage: 'Skip 15 seconds forward',
		description:
			'The label is used for accessibility for the icon button which will skip the currently active audio forward "x" seconds',
	},
});

export type SkipForwardButtonProps = {
	isDisabled?: boolean;
	onClick?: () => void;
};

export const SkipForwardButton = ({
	onClick = () => {},
	isDisabled = false,
}: SkipForwardButtonProps): React.ReactNode => {
	const intl = useIntl();
	const { audioRef } = useAudioPlayerStreamingContext();

	const handleSkipForward = () => {
		const audio = audioRef.current;
		if (audio && audio.duration) {
			const remaining = audio.duration - audio.currentTime;
			if (remaining <= SKIP_SECONDS) {
				audio.currentTime = audio.duration;
			} else {
				audio.currentTime += SKIP_SECONDS;
			}
		}
	};

	const handleClick = () => {
		onClick?.();
		handleSkipForward();
	};

	return (
		<AudioControlIconButton
			Icon={VideoSkipForwardFifteenIcon}
			label={intl.formatMessage(i18n.skipForwardButtonLabel)}
			tooltip={intl.formatMessage(i18n.skipForwardButtonTooltip)}
			onClick={handleClick}
			isDisabled={isDisabled}
			testId="miniplayer-skip-forward"
		/>
	);
};
